import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const useAppStore = defineStore('app', () => {
	const seoUser = ref(true);
	const xServeTrack = ref<string | null | undefined>(null);
	const ssrTodaysDate = ref<Date | null>(null);
	const isUsingAdBlocker = ref(false);

	const isSeoUser = computed(() => {
		return seoUser.value;
	});

	function setSeoUser(value: boolean) {
		seoUser.value = value;
	}

	function setXServeTrack(value: string | null | undefined) {
		xServeTrack.value = value;
	}

	function setSSRTodaysDate(value: Date | null) {
		if (!import.meta.server) return;

		const current = ssrTodaysDate.value;
		const currentInvalid = current instanceof Date && Number.isNaN(current.getTime());

		if (!current || currentInvalid) {
			ssrTodaysDate.value = value;
		}
	}

	function setIsUsingAdBlocker(value: boolean) {
		isUsingAdBlocker.value = value;
	}

	return {
		seoUser,
		xServeTrack,
		ssrTodaysDate,
		isUsingAdBlocker,

		isSeoUser,

		setSeoUser,
		setXServeTrack,
		setSSRTodaysDate,
		setIsUsingAdBlocker,
	};
});
